import { downloadToCSV, useTranslation, zonedToUTC, zonedToUTCAdd1Day } from '@fareye/common'
import { LANGUAGE_STRINGS, TRN_CONSTANTS } from '@fareye/configs'
import { Button, toast } from '@fareye/ui'
import { cancelToken, dMmm, get, getXlsx, post, postXlsx } from '@fareye/utils'
import queryString from 'query-string'
import React from 'react'
import { HEADER_INFLECTION } from '../../../config/constants'

interface IDownloadExcelButton {
  downloadConfig: {
    downloadUrl: string
    isStream: boolean
    type: 'GET' | 'POST'
    query: any
  }
  fileName: string
  data: Array<any>
}
export default function DownloadExcelButton({
  downloadConfig,
  fileName,
  data
}: IDownloadExcelButton) {
  const isDisabledForDateRange = React.useMemo(() => {
    var startTime = null
    var endTime = null
    if (downloadConfig?.query?.filter?.length) {
      downloadConfig?.query?.filter?.forEach((filter: any) => {
        filter.forEach((item: any) => {
          if (item.filterKey === 'start_date' && item.filterType === 'gte') {
            startTime = new Date(item.filterValue).getTime()
          } else if (
            item.filterKey === 'start_date' &&
            item.filterType === 'lt'
          ) {
            endTime = new Date(item.filterValue).getTime()
          }
        })
      })
    } else if (downloadConfig.downloadUrl?.split('?')?.[1]) {
      const searchParams: any = queryString.parse(
        downloadConfig.downloadUrl.split('?')[1]
      )
      const startDate = searchParams?.start_date || searchParams?.startDate
      const endDate = searchParams?.end_date || searchParams?.endDate
      startTime = zonedToUTC(startDate).getTime()
      endTime = zonedToUTCAdd1Day(endDate).getTime()
    }
    return Boolean(
      startTime &&
        endTime &&
        (endTime - startTime) / 1000 / 60 / 60 / 24 > TRN_CONSTANTS.maxDownloadDays
    )
  }, [downloadConfig.downloadUrl, downloadConfig.query])
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const { t } = useTranslation()

  const source = cancelToken().source()
  async function downloadCSV() {
    try {
      const { isStream, downloadUrl, type, query } = downloadConfig
      setDownloadLoading(true)
      if (isStream) {
        const { data }: any = await (type === 'GET'
          ? getXlsx(downloadUrl, source.token)
          : postXlsx(downloadUrl, query, source.token))
        downloadToCSV({
          data,
          fileName: `${fileName}-${dMmm()}`,
          type: 'text/zip',
          extension: 'zip'
        })
      } else {
        const { data }: any = await (type === 'GET'
          ? get(downloadUrl, source.token, HEADER_INFLECTION)
          : post(downloadUrl, query, source.token, HEADER_INFLECTION))
        downloadToCSV({
          data: (data as any)['content'],
          fileName: `${fileName}-${dMmm()}`,
          extension: 'csv'
        })
      }
      setDownloadLoading(false)
    } catch (ex:any) {
      setDownloadLoading(false)
      toast.error(t('Something went wrong ....'))
      console.warn(ex)
    }
  }
  return (
    <span
      title={
        isDisabledForDateRange
          ? t(LANGUAGE_STRINGS.MAX_DOWNLOAD, {
              MAX_DOWNLOAD: TRN_CONSTANTS.maxDownloadDays
            })
          : t('Export as Excel')
      }
    >
      <Button
        variant="primary m"
        disabled={isDisabledForDateRange}
        onClick={() => downloadCSV()}
        isLoading={downloadLoading}
        style={{ marginRight: '20px' }}
      >
        {t('Export as Excel')}
      </Button>
    </span>
  )
}
